import {Typed} from "app/stimulus/typed-stimulus";
import {LiveComponentToolsController} from "app/stimulus/live-component-tools-controller";
import {Controller} from "@hotwired/stimulus";
import {AsStimulusController} from "app/stimulus/as-stimulus-controller";

@AsStimulusController('crm-person-detail-api3-credentials')
export default class extends Typed(LiveComponentToolsController(Controller<HTMLElement>))
{
    public async showList(): Promise<void> {
        const component = await this.getComponent();
        await component.action('showList');
    }
}
